import { useLocation } from "react-router-dom";

export type Lang = "fr" | "en";

type Dict = Record<string, string>;

const fr: Dict = {
  // Header
  "header.discuter": "Discuter",
  "header.discuter_aria": "Discuter avec Ombeline",
  "header.demande_short": "Demande",
  "header.envoyer_demande": "Envoyer ma demande",
  "header.plateforme_short": "Plateforme",
  "header.plateforme_full": "Accéder à la plateforme Société Générale",
  "header.pill_role": ", votre conseillère ",
  "header.pill_role_suffix": "",

  // Helmet
  "seo.title": "Naboo × Société Générale — Plateforme événementielle dédiée aux collaborateurs Société Générale",
  "seo.description": "Plateforme Naboo réservée exclusivement aux collaborateurs Société Générale : organisez vos séminaires, événements et team building avec des conditions négociées et un accompagnement dédié par Ombeline.",
  "seo.og.description": "Espace privé Société Générale × Naboo : organisez vos séminaires et événements d'entreprise avec tarifs négociés et accompagnement dédié. Réservé aux équipes Société Générale.",
  "seo.og.image_alt": "Logos Société Générale et Naboo — Votre plateforme événementielle dédiée",
  "seo.twitter.title": "Naboo × Société Générale — Plateforme événementielle dédiée",
  "seo.twitter.description": "Espace privé Société Générale × Naboo : séminaires, événements et team building avec tarifs négociés et conseillère dédiée.",
  "seo.twitter.image_alt": "Naboo × Société Générale — Plateforme événementielle dédiée",
  "seo.author": "Naboo pour Société Générale",
  "seo.locale": "fr_FR",
  "html.lang": "fr",

  // Hero
  "hero.badge": "Quiz",
  "hero.title": "Quelques questions rapides pour trouver votre lieu idéal.",
  "hero.step.type": "Type d'événement",
  "hero.step.dates": "Dates",
  "hero.step.participants": "Participants",
  "hero.step.match": "Votre match",
  "hero.cta": "Démarrer →",
  "hero.subline": "Résultats en moins de 30 sec",

  // Stats
  "stats.partnership_value": "9",
  "stats.partnership": "Années de partenariat",
  "stats.events": "Nb événements",
  "stats.participants": "Nb participants",
  "stats.colleagues": "Collègues inscrits",

  // Colleagues
  "colleagues.title": "Déjà 191 collègues Société Générale sont inscrits sur Naboo",
  "colleagues.paragraph": "Retrouvez l'historique de vos événements, le suivi de vos projets en cours et tous vos devis au même endroit.",
  "colleagues.cta": "Créer un compte →",
  "colleagues.label": "Vos collègues utilisent déjà Naboo",
  "colleagues.more": "collègues",

  // Top destinations
  "destinations.title": "Top destinations",
  "destinations.instant": "Réservation instantanée",
  "destinations.bottom_title": "Découvrez plus de 50 000 lieux et prestataires dans notre base de données",
  "destinations.bottom_subtitle": "Explorez l'ensemble du catalogue Naboo réservé aux équipes Société Générale.",
  "destinations.bottom_cta": "Explorer les lieux →",

  // Push
  "push.line1": "Votre lieu idéal en 30 sec",
  "push.line2": "Quiz Naboo",
  "push.close": "Fermer",

  // Events
  "events.title": "Organisez tout type d'événement, de 5 à 500 participants, partout dans le monde",
  "events.prev": "Précédent",
  "events.next": "Suivant",
  "events.go_to": "Aller à l'événement",
  "events.stay": "Séjour avec nuitée",
  "events.conf": "Conférences",
  "events.rooms": "Réservation de chambres pour expositions et salons",
  "events.awayday": "Journée externe | Réunion | Session de formation",
  "events.parties": "Soirées d'entreprise | Afterworks",
  "events.meals": "Repas d'affaires | Traiteur",
  "events.tb": "Activité team building",

  // Services
  "services.title": "Une seule plateforme pour toute votre logistique",
  "services.paragraph": "De la salle de réunion au bus de transfert, on s'occupe de tout. Vous n'avez qu'un seul interlocuteur : Ombeline.",
  "services.catering": "Restauration & traiteurs",
  "services.animation": "Animation & speakers",
  "services.transport": "Transport & transferts",
  "services.hotels": "Hôtels & lieux",
  "services.coworking": "Salles & coworking",
  "services.more": "+ tout autre service événementiel sur demande",

  // Preferred terms
  "pt.title": "Bénéficiez de conditions préférentielles",
  "pt.col.invoicing": "Portage de factures",
  "pt.col.standard": "Service Standard",
  "pt.col.turnkey": "Service Clé en Main",
  "pt.group.admin": "Admin",
  "pt.group.search": "Recherche de lieu",
  "pt.group.management": "Gestion d'événement",
  "pt.row.fees": "Frais",
  "pt.row.advance": "Avance d'acompte",
  "pt.row.referencing": "Référencement de nouveaux lieux et prestataires via Naboo",
  "pt.row.autonomy": "Autonomie complète sur la plateforme",
  "pt.row.delegation": "Délégation du brief à un expert événementiel avec suggestions et support illimités",
  "pt.row.assistance": "Assistance illimitée pour négocier les prix et conditions",
  "pt.row.app": "Application événementielle pour organisateurs et participants",
  "pt.row.visit": "Visite du site",
  "pt.row.coordination": "Coordination des prestataires après signature du devis",
  "pt.row.onsite": "Gestionnaire d'événement sur place pendant l'événement (>40K€)",
  "pt.discover_fees": "Découvrez nos frais",
  "pt.cta": "Découvrir la plateforme Société Générale",

  // How to
  "how.badge": "En 6 étapes simples",
  "how.title": "Comment faire ?",
  "how.step": "Étape",
  "how.of": "/",
  "how.prev": "Étape précédente",
  "how.next": "Étape suivante",
  "how.go_to": "Aller à l'étape",
  "how.s1.title": "Envoyez votre brief",
  "how.s1.desc": "Envoyez votre brief à votre expert événementiel (via la plateforme, par email ou par téléphone) ou recherchez en utilisant la barre de recherche en toute autonomie.",
  "how.s1.link.platform": "Lien vers la plateforme",
  "how.s2.title": "Obtenez une réponse rapide",
  "how.s2.desc": "Votre expert événementiel répond dans l'heure, fait les premières suggestions dans les 2 heures et finalise vos devis dans les 2 jours.",
  "how.s3.title": "Demandez des ajustements",
  "how.s3.desc": "Demandez des ajustements ou de nouvelles propositions. Votre expert met tout à jour dans les 24 heures jusqu'à ce que vous soyez prêt à confirmer votre réservation. Les ajustements sont illimités.",
  "how.s4.title": "Confirmez la réservation",
  "how.s4.desc": "Quand vous êtes satisfait de vos devis, téléchargez le devis qui correspond à vos attentes et lancez votre processus de demande d'achat.",
  "how.s5.title": "Créez votre demande d'achat",
  "how.s5.desc": "Pendant la validation de votre demande d'achat, cliquez sur 'Confirmer la réservation' sur la plateforme pour télécharger la facture finale et transformer votre demande d'achat en bon de commande. Naboo s'occupe de tout.",
  "how.s6.title": "Obtenez un support complet (optionnel)",
  "how.s6.desc": "Si vous avez besoin d'aide pour organiser votre événement, Naboo peut vous fournir un support complet de gestionnaire d'événement jusqu'au jour de l'événement, il suffit de demander !",

  // Footer
  "footer.terms": "Conditions générales d'utilisation",
  "footer.cgu": "CGU",
  "footer.contact": "Contactez-nous",
  "footer.cookies": "Modifier vos préférences de cookies",
  "footer.linkedin": "LinkedIn",
  "footer.instagram": "Instagram",
  "footer.email": "Email",

  // Popover
  "pop.subject": "Demande Société Générale",
  "pop.copy": "Copier l'email",
  "pop.gmail": "Ouvrir dans Gmail",
  "pop.outlook": "Ouvrir dans Outlook",
  "pop.mail_app": "Utiliser mon application mail",
  "pop.copied": "Email copié",
  "pop.copy_error": "Impossible de copier",

  // Lang
  "lang.fr": "FR",
  "lang.en": "EN",

  // Quiz
  "quiz.step.type": "Type",
  "quiz.step.dates": "Dates",
  "quiz.step.categories": "Catégories",
  "quiz.step.participants": "Participants",
  "quiz.step.standing": "Standing",
  "quiz.step.match": "Match",
  "quiz.title.type": "Quel type d'événement organisez-vous ?",
  "quiz.title.categories": "Quelle ambiance recherchez-vous ?",
  "quiz.title.participants": "Combien de participants ?",
  "quiz.title.standing": "Quel est votre budget ?",
  "quiz.title.dates_prefix": "Quand a lieu votre ",
  "quiz.title.dates_suffix": " ?",
  "quiz.title.event_word": "événement",
  "quiz.label.0": "Type d'événement",
  "quiz.label.1": "Dates",
  "quiz.label.2": "Catégories",
  "quiz.label.3": "Participants",
  "quiz.label.4": "Budget",
  "quiz.label.5": "Vos coordonnées",
  "quiz.month.0": "Janvier",
  "quiz.month.1": "Février",
  "quiz.month.2": "Mars",
  "quiz.month.3": "Avril",
  "quiz.month.4": "Mai",
  "quiz.month.5": "Juin",
  "quiz.month.6": "Juillet",
  "quiz.month.7": "Août",
  "quiz.month.8": "Septembre",
  "quiz.month.9": "Octobre",
  "quiz.month.10": "Novembre",
  "quiz.month.11": "Décembre",
  "quiz.evt.seminaire": "Séminaire d'entreprise",
  "quiz.evt.journee_hors_site": "Journée hors site",
  "quiz.evt.soiree": "Soirée d'entreprise",
  "quiz.evt.team_building": "Activité team building",
  "quiz.evt.conference": "Conférence",
  "quiz.evt.lancement_produit": "Lancement de produit",
  "quiz.evt.autre": "Autre",
  "quiz.evt.placeholder": "Précisez le type d'événement",
  "quiz.cat.Plage": "Plage",
  "quiz.cat.Montagne": "Montagne",
  "quiz.cat.Ville": "Ville",
  "quiz.cat.Nature": "Nature",
  "quiz.cat.Désert": "Désert",
  "quiz.cat.Tropical": "Tropical",
  "quiz.cat.Bord de lac": "Bord de lac",
  "quiz.cat.Île": "Île",
  "quiz.cat.Historique": "Historique",
  "quiz.cat.Luxe": "Luxe",
  "quiz.cat.Aventure": "Aventure",
  "quiz.cat.Bien-être": "Bien-être",
  "quiz.dates.placeholder": "Choisir une date",
  "quiz.dates.or_month": "Ou choisissez un mois",
  "quiz.participants.hint": "Nombre de participants",
  "quiz.participants.placeholder": "Ex : 25",
  "quiz.budget.per_person": "soit {p} € par personne",
  "quiz.budget.or": "OU",
  "quiz.budget.placeholder": "Budget total exact",
  "quiz.budget.exact": "Saisir un montant exact",
  "quiz.standing.Essentiel": "Essentiel",
  "quiz.standing.Confort": "Confort",
  "quiz.standing.Premium": "Premium",
  "quiz.standing.Prestige": "Prestige",
  "quiz.standing.Exception": "Exception",
  "quiz.match.title": "Recevez vos suggestions",
  "quiz.match.subtitle": "Indiquez votre email professionnel pour recevoir votre sélection personnalisée.",
  "quiz.match.email_placeholder": "votre.email@socgen.com",
  "quiz.match.cta": "Recevoir mes suggestions",
  "quiz.match.sending": "Envoi en cours…",
  "quiz.match_suffix": "% de match",
  "quiz.email.required": "Email requis",
  "quiz.email.invalid": "Email invalide",
  "quiz.email.pro": "Merci d'utiliser votre email professionnel",
  "quiz.success.title": "Demande envoyée !",
  "quiz.success.subtitle": "Ombeline revient vers vous très rapidement avec une sélection personnalisée.",
  "quiz.success.close": "Fermer",
  "quiz.nav.back": "Retour",
  "quiz.nav.next": "Suivant",
  "quiz.aria.close": "Fermer",
  "quiz.tier.Petit comité": "Petit comité",
  "quiz.tier.Groupe convivial": "Groupe convivial",
  "quiz.tier.Grande équipe": "Grande équipe",
  "quiz.tier.Grand événement": "Grand événement",
  "quiz.tier.Événement XL": "Événement XL",

  // AI Planner
  "ai_planner.pill": "Nouveau · IA",
  "ai_planner.title": "Construisons votre prochain événement",
  "ai_planner.description": "Décrivez votre événement et notre IA vous suggérera des options personnalisées.",
  "ai_planner.cta": "Essayer l'IA planner",
};

const en: Dict = {
  ...fr,
  "header.discuter": "Chat",
  "header.discuter_aria": "Chat with Ombeline",
  "header.demande_short": "Request",
  "header.envoyer_demande": "Send my request",
  "header.plateforme_short": "Platform",
  "header.plateforme_full": "Go to the Société Générale platform",
  "header.pill_role": ", your ",
  "header.pill_role_suffix": " advisor",

  "seo.title": "Naboo × Société Générale — Event platform dedicated to Société Générale employees",
  "seo.description": "Naboo platform reserved exclusively to Société Générale employees: organise your seminars, events and team building with negotiated terms and dedicated support by Ombeline.",
  "seo.og.description": "Private Société Générale × Naboo space: organise corporate events with negotiated rates and dedicated support.",
  "seo.og.image_alt": "Société Générale and Naboo logos — Your dedicated event platform",
  "seo.twitter.title": "Naboo × Société Générale — Dedicated event platform",
  "seo.twitter.description": "Private Société Générale × Naboo space: seminars, events and team building with negotiated rates and a dedicated advisor.",
  "seo.twitter.image_alt": "Naboo × Société Générale — Dedicated event platform",
  "seo.author": "Naboo for Société Générale",
  "seo.locale": "en_GB",
  "html.lang": "en",

  "hero.title": "A few quick questions to find your ideal venue.",
  "hero.step.type": "Event type",
  "hero.step.dates": "Dates",
  "hero.step.participants": "Participants",
  "hero.step.match": "Your match",
  "hero.cta": "Start →",
  "hero.subline": "Results in under 30 sec",

  "stats.partnership_value": "9",
  "stats.partnership": "Years of partnership",
  "stats.events": "Events",
  "stats.participants": "Participants",
  "stats.colleagues": "Registered colleagues",

  "colleagues.title": "191 Société Générale colleagues are already on Naboo",
  "colleagues.paragraph": "Find the history of your events, the follow-up of your ongoing projects and all your quotes in one place.",
  "colleagues.cta": "Create an account →",
  "colleagues.label": "Your colleagues already use Naboo",
  "colleagues.more": "colleagues",

  "destinations.title": "Top destinations",
  "destinations.instant": "Instant booking",
  "destinations.bottom_title": "Discover over 50,000 venues and service providers in our database",
  "destinations.bottom_subtitle": "Explore the full Naboo catalogue reserved for Société Générale teams.",
  "destinations.bottom_cta": "Explore venues →",

  "push.line1": "Your ideal venue in 30 sec",
  "push.line2": "Naboo Quiz",
  "push.close": "Close",

  "events.title": "Organise any type of event, from 5 to 500 participants, anywhere in the world",
  "events.prev": "Previous",
  "events.next": "Next",
  "events.go_to": "Go to event",
  "events.stay": "Overnight retreat",
  "events.conf": "Conferences",
  "events.rooms": "Exhibitions | Fairs",
  "events.awayday": "Away-day | Meeting | Training session",
  "events.parties": "Corporate parties | Afterworks",
  "events.meals": "Business meals | Catering",
  "events.tb": "Team building activity",

  "services.title": "One platform for all your logistics",
  "services.paragraph": "From meeting rooms to bus transfers, we handle everything. You only have one contact: Ombeline.",
  "services.catering": "Catering & restaurants",
  "services.animation": "Speakers & entertainment",
  "services.transport": "Transport & transfers",
  "services.hotels": "Hotels & venues",
  "services.coworking": "Meeting rooms & coworking",
  "services.more": "+ any other event service on demand",

  "pt.title": "Benefit from preferential rates",
  "pt.col.invoicing": "Invoice carrying",
  "pt.col.standard": "Standard Service",
  "pt.col.turnkey": "Turnkey Service",
  "pt.group.admin": "Admin",
  "pt.group.search": "Venue finding",
  "pt.group.management": "Event management",
  "pt.row.fees": "Fees",
  "pt.row.advance": "Deposit advance payment",
  "pt.row.referencing": "Listing of new venues and providers via Naboo",
  "pt.row.autonomy": "Full autonomy on the platform",
  "pt.row.delegation": "Brief delegation to event expert with unlimited suggestions and support",
  "pt.row.assistance": "Unlimited assistance to negotiate prices and T&Cs",
  "pt.row.app": "Event app for organisers and participants",
  "pt.row.visit": "Site visit",
  "pt.row.coordination": "Coordination of providers after signing the quote",
  "pt.row.onsite": "On-site event manager during the event (>€40K)",
  "pt.discover_fees": "Discover our fees",
  "pt.cta": "Discover the Société Générale platform",

  "how.badge": "In 6 simple steps",
  "how.title": "How does it work?",
  "how.step": "Step",
  "how.prev": "Previous step",
  "how.next": "Next step",
  "how.go_to": "Go to step",
  "how.s1.title": "Send your brief",
  "how.s1.desc": "Send your brief to your event expert (via the platform, email or phone) or search using the search bar in full autonomy.",
  "how.s1.link.platform": "Link to the platform",
  "how.s2.title": "Get a prompt answer",
  "how.s2.desc": "Your event expert answers within 1 hour, makes first suggestions within 2 hours, and finalises quotes within 2 days.",
  "how.s3.title": "Ask for adjustments",
  "how.s3.desc": "Ask for adjustments or new proposals. Your expert updates everything within 24 hours until you are ready to confirm. Adjustments are unlimited.",
  "how.s4.title": "Confirm booking",
  "how.s4.desc": "When you are happy with your quotes, download the one that meets your expectations and start your purchase request.",
  "how.s5.title": "Create your purchase request",
  "how.s5.desc": "While your PR is being validated, click 'Confirm booking' on the platform to download the final invoice and transform it into a PO. Naboo handles the payment.",
  "how.s6.title": "Get full support (optional)",
  "how.s6.desc": "If you need help organising your event, Naboo can provide full event manager support up until the day of the event — just ask!",

  "footer.terms": "General terms of use",
  "footer.cgu": "T&Cs",
  "footer.contact": "Contact us",
  "footer.cookies": "Change your cookie preferences",

  "pop.subject": "Société Générale request",
  "pop.copy": "Copy email",
  "pop.gmail": "Open in Gmail",
  "pop.outlook": "Open in Outlook",
  "pop.mail_app": "Use my mail app",
  "pop.copied": "Email copied",
  "pop.copy_error": "Unable to copy",

  // Quiz EN
  "quiz.step.type": "Type",
  "quiz.step.dates": "Dates",
  "quiz.step.categories": "Categories",
  "quiz.step.participants": "Participants",
  "quiz.step.standing": "Standing",
  "quiz.step.match": "Match",
  "quiz.title.type": "What type of event are you organising?",
  "quiz.title.categories": "What atmosphere are you looking for?",
  "quiz.title.participants": "How many participants?",
  "quiz.title.standing": "What is your budget?",
  "quiz.title.dates_prefix": "When is your ",
  "quiz.title.dates_suffix": "?",
  "quiz.title.event_word": "event",
  "quiz.label.0": "Event type","quiz.label.1": "Dates","quiz.label.2": "Categories","quiz.label.3": "Participants","quiz.label.4": "Budget","quiz.label.5": "Your details",
  "quiz.month.0": "January","quiz.month.1": "February","quiz.month.2": "March","quiz.month.3": "April","quiz.month.4": "May","quiz.month.5": "June","quiz.month.6": "July","quiz.month.7": "August","quiz.month.8": "September","quiz.month.9": "October","quiz.month.10": "November","quiz.month.11": "December",
  "quiz.evt.seminaire": "Corporate seminar",
  "quiz.evt.journee_hors_site": "Offsite day",
  "quiz.evt.soiree": "Corporate party",
  "quiz.evt.team_building": "Team building activity",
  "quiz.evt.conference": "Conference",
  "quiz.evt.lancement_produit": "Product launch",
  "quiz.evt.autre": "Other",
  "quiz.evt.placeholder": "Specify the event type",
  "quiz.cat.Plage": "Beach","quiz.cat.Montagne": "Mountain","quiz.cat.Ville": "City","quiz.cat.Nature": "Nature","quiz.cat.Désert": "Desert","quiz.cat.Tropical": "Tropical","quiz.cat.Bord de lac": "Lakeside","quiz.cat.Île": "Island","quiz.cat.Historique": "Historic","quiz.cat.Luxe": "Luxury","quiz.cat.Aventure": "Adventure","quiz.cat.Bien-être": "Wellness",
  "quiz.dates.placeholder": "Pick a date",
  "quiz.dates.or_month": "Or pick a month",
  "quiz.participants.hint": "Number of participants",
  "quiz.participants.placeholder": "E.g. 25",
  "quiz.budget.per_person": "i.e. €{p} per person",
  "quiz.budget.or": "OR",
  "quiz.budget.placeholder": "Exact total budget",
  "quiz.budget.exact": "Enter an exact amount",
  "quiz.standing.Essentiel": "Essential","quiz.standing.Confort": "Comfort","quiz.standing.Premium": "Premium","quiz.standing.Prestige": "Prestige","quiz.standing.Exception": "Exceptional",
  "quiz.match.title": "Receive your suggestions",
  "quiz.match.subtitle": "Enter your work email to receive your personalised selection.",
  "quiz.match.email_placeholder": "your.email@socgen.com",
  "quiz.match.cta": "Get my suggestions",
  "quiz.match.sending": "Sending…",
  "quiz.match_suffix": "% match",
  "quiz.email.required": "Email required",
  "quiz.email.invalid": "Invalid email",
  "quiz.email.pro": "Please use your work email",
  "quiz.success.title": "Request sent!",
  "quiz.success.subtitle": "Ombeline will get back to you very shortly with a personalised selection.",
  "quiz.success.close": "Close",
  "quiz.nav.back": "Back",
  "quiz.nav.next": "Next",
  "quiz.aria.close": "Close",
  "quiz.tier.Petit comité": "Small group",
  "quiz.tier.Groupe convivial": "Friendly group",
  "quiz.tier.Grande équipe": "Large team",
  "quiz.tier.Grand événement": "Large event",
  "quiz.tier.Événement XL": "XL event",
  "ai_planner.pill": "New · AI",
  "ai_planner.title": "Let's build your next event",
  "ai_planner.description": "Describe your event and our AI will suggest tailored options.",
  "ai_planner.cta": "Try the AI planner",
};

const dicts: Record<Lang, Dict> = { fr, en };

export function detectLang(pathname: string): Lang {
  if (pathname.startsWith("/en")) return "en";
  if (pathname.startsWith("/fr")) return "fr";
  return "fr";
}

export function useArkemaLang() {
  const { pathname, search } = useLocation();
  const lang = detectLang(pathname);
  const t = (key: string): string => dicts[lang][key] ?? dicts.en[key] ?? key;
  const switchPath = (target: Lang): string => `/${target}${search || ""}`;
  return { lang, t, switchPath };
}

export function getT(lang: Lang) {
  return (key: string): string => dicts[lang][key] ?? dicts.en[key] ?? key;
}
